export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 16 14",
      url: "../icon/" + "icons.svg#icon-arrow-usage",
      toString: function () {
        return this.url;
      }
    }